module.exports = __webpack_public_path__ + "img/BlueBerry.6bb53f5e.svg";